import React, { Suspense } from "react";
import AppBar from "@material-ui/core/AppBar";
import { Toolbar, IconButton } from "@material-ui/core";
import Tabs from "@material-ui/core/Tabs";
import Tab from "@material-ui/core/Tab";
import { withStyles, withTheme } from "@material-ui/core/styles";
import { Redirect, withRouter } from "react-router-dom";
import { compose } from "recompose";
import Menu from "@material-ui/core/Menu";
import { observer, inject } from "mobx-react";
import { withUserProfile } from "../../../userProfile/userProfileContext";
import { getDataWithQueryString } from "../../../api/componentAPIs";
import Events from "../../../utilities/EventEmitter";
import { withSnackbar } from "notistack";
import appConstants from "../../../appConstants";
import MoreVert from "@material-ui/icons/MoreVert";
import Tooltip from "../../common/StyledToolTip";
import styles from "../headerStyles";
import ModuleSwitcher from "../ModuleSwitcher";
import RightNavigationMenu from "./rightNavigationMenu";
import withWidth from "@material-ui/core/withWidth";
import { AppLoading } from "../../../loaders/loaders";
import { groupBy, sortBy } from "lodash";
import {
  getSelectedMapFilters,
} from "../../modules/Dispatch/RouteExecution/filterUtils";
import ToastNotifications from "./Notifications/ToastNotifications";
import ParameterListener from "../Parameters";
import getDataWithAbort from "../../../api/getDataWithAbort";

const DispatchOptimizationDialog = React.lazy(() =>
  import("./PickupOptimization")
);
const LoaderDialog = React.lazy(() =>
  import("./DispatchLoader")
);
const TerminalSelect = React.lazy(() => import("../terminalSelect"));

const DispatchTabs = {
  assetManagement: {
    label: "Asset Management",
    id: "AssetManagementHeader",
    path: appConstants.NAV_URLS.DISPATCH_ASSET_MANAGEMENT,
  },
  routeExecution: {
    label: "Route Execution",
    id: "RoutesExecutionHeader",
    path: appConstants.NAV_URLS.DISPATCH_ROUTEEXECUTION,
  },
  driverPerformance: {
    label: "Driver Performance",
    id: "DriverPerformanceHeader",
    path: appConstants.NAV_URLS.REPORT_DRIVER_PERFORMANCE_LIVE,
  },
};

@inject("DispatchStore")
@observer
class DispatchHeader extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      currentTabValue:
        this.props.path && this.props.path.params.moduleName
          ? this.props.path.url.toLowerCase()
          : false,
      isDataRefreshProgress: false,
      currentPlanDate: null,
      isDialogOpen: false,
      title: "",
      showLoader: false,
      eventName: null,
      isPickupOptimizationInProgress: false,
      processedPickups: [],
      showNotification: false,
    };

    this.userProfileData = {
      terminal: this.props.userData.userProfile.terminal.code,
      userName: this.props.userData.userProfile.userName,
      planDate: this.props.userData.userProfile.planDate,
    };
    this.timer = null;
    this.pendingPickupEvent = null;
    this.pendingUpdateDriverIds = [];
  }

  componentDidMount() {
    const { DispatchStore } = this.props;
    !DispatchStore.staticClientData && this.populateStaticData();
    Events.on("RedirectToPage", this.handleChange);
    Events.on("ShowLoaderDialog", this.showLoaderDialog);
    Events.on("RefreshDispatchStore", this.refreshDispatchStore);
    Events.on("HideLoaderDialog", this.hideLoaderDialog);
    Events.on("AddDriverLocation", this.addDriverLocation);
    Events.on("HandlePickupEvent", this.handlePickupEvent);
    Events.on("RefreshPickupsData", this.onPickupUpdated);
    Events.on("UpdateDriverLoginStatus", this.updateDriverLoginStatus);
    Events.on(
      "UpdatePickupAcknowledgedStatus",
      this.updatePickupAcknowledgedStatus
    );
    Events.on("stopMoved", this.stopMoved);
    Events.on(
      "showPickupTerminalChangeMessage",
      this.showPickupTerminalChangeMessage
    );
    this.updateMapFilters();
    Events.on("UpdateDriverRoute", this.updateDriverRoute);
    Events.on("refreshDispatchKPI", this.refreshDispatchKPI);
    this.refreshDispatchStore({initialRefresh: true});
    this.refreshDuplicatePickups();
    Events.on("RefreshDuplicatePickups", this.refreshDuplicatePickups);
  }

  componentWillUnmount() {
    Events.removeListener("RedirectToPage", this.handleChange);
    Events.removeListener("RefreshDispatchStore", this.refreshDispatchStore);
    Events.removeListener("ShowLoaderDialog", this.showLoaderDialog);
    Events.removeListener("HideLoaderDialog", this.hideLoaderDialog);
    Events.removeListener("AddDriverLocation", this.addDriverLocation);
    Events.removeListener("HandlePickupEvent", this.handlePickupEvent);
    Events.removeListener("RefreshPickupsData", this.onPickupUpdated);
    Events.removeListener("UpdateDriverRoute", this.updateDriverRoute);
    Events.removeListener(
      "UpdateDriverLoginStatus",
      this.updateDriverLoginStatus
    );
    Events.removeListener(
      "UpdatePickupAcknowledgedStatus",
      this.updatePickupAcknowledgedStatus
    );
    Events.removeListener(
      "showPickupTerminalChangeMessage",
      this.showPickupTerminalChangeMessage
    );
    Events.removeListener("stopMoved", this.stopMoved);
    Events.removeListener("refreshDispatchKPI", this.refreshDispatchKPI);
    Events.removeListener(
      "RefreshDuplicatePickups",
      this.refreshDuplicatePickups
    );
    this.pendingPickupEvent = null;
  }
  switchNotificationPanel = (value = null) => {
    this.setState((prevState) => ({
      showNotification: value ?? !prevState.showNotification,
    }));
  };

  updateDriverLoginStatus = (data) => {
    const { driverId } = JSON.parse(data);
    this.refreshDispatchRoutes([driverId]);
    this.refreshDriversList();
    this.refreshDispatchKPI();
  };

  handlePickupEvent = (data, eventName) => {
    const pickupData = JSON.parse(data);
    if (pickupData.success) {
      pickupData.pickupId = pickupData.pickupId ?? "";
       this.pendingUpdateDriverIds = [...new Set([...this.pendingUpdateDriverIds, pickupData.driverId])]
    } else {
      pickupData.pickupId = pickupData.pickupId[0] ?? "";
    }

    if (this.state.isPickupOptimizationInProgress) {
      Events.emit("ShowpickupOptimizationLogs", pickupData, eventName);
    } else if (
      [
        appConstants.PICKUP_EVENTS.ASSIGN_PICKUP,
        appConstants.PICKUP_EVENTS.UNASSIGN_PICKUP,
      ].includes(eventName)
    ) {
      Events.emit("showAssignPickupNotification", pickupData, eventName);
    }

    if (!this.pendingPickupEvent) {
      const driverIds = this.pendingUpdateDriverIds.slice();
      this.pendingUpdateDriverIds = [];
      this.refreshDispatchStore({driverIds});
    } else {
      if (
        this.pendingPickupEvent?.eventType?.toLowerCase() ===
        eventName.toLowerCase()
      ) {
        this.pendingPickupEvent.pickupIds =
          this.pendingPickupEvent.pickupIds.filter(
            (pendingPickupId) =>
              pendingPickupId.toLowerCase() !==
              pickupData.pickupId.toLowerCase()
          );
        this.setState((state) => ({
          processedPickups: [...state.processedPickups, pickupData.pickupId],
        }));
      }

      if (!this.pendingPickupEvent?.pickupIds.length) {
        this.pendingPickupEvent = null;
         const driverIds = this.pendingUpdateDriverIds.slice();
         this.pendingUpdateDriverIds = [];
         this.refreshDispatchStore({ driverIds });
      }
    }
  };

  componentDidUpdate(prevProps) {
    if (this.props.width !== prevProps.width) {
      this.setState({ terminalanchorEl: null });
    }
    if (
      this.props.userData.userProfile.terminal.id !==
        prevProps.userData.userProfile.terminal.id ||
      this.props.userData.userProfile.scenarioID !==
        prevProps.userData.userProfile.scenarioID
    ) {
      this.refreshDispatchStore({initialRefresh: true});
      this.refreshDuplicatePickups();
      this.pendingPickupEvent = null;
      this.setState({ processedPickups: [] });
    }
  }

  updateMapFilters = () => {
    const stopFilter = getSelectedMapFilters(
      this.props.DispatchStore.stopsFilter
    );
    this.props.DispatchStore.updateMapFilter(stopFilter);
  };

  updateDriverRoute = (driverId) => {
    const driverIdList = Array.isArray(driverId)
      ? driverId.map((d) => d.toUpperCase())
      : [driverId.toUpperCase()];
    if (!driverIdList.length) {
      return;
    }
    this.pendingUpdateDriverIds.push(...driverIdList);
    console.info(
      `Driver ${driverIdList.join(
        ", "
      )} update notification received at ${new Date().toLocaleString()}`
    );
    this.updateDriverInfo();
  };

  updateDriverInfo = () => {
    const driversToUpdate = [
      ...new Set([...this.pendingUpdateDriverIds]),
    ].slice();
    this.pendingUpdateDriverIds = [];

    console.info("Refreshing pending Drivers at ", new Date().toLocaleString());
    // fetch Data for pending driverIds
    this.refreshDispatchRoutes(driversToUpdate);
    this.refreshDispatchKPI();
    this.refreshPickupList();
  };

  showLoaderDialog = (event) => {
    this.pendingPickupEvent = [
      appConstants.PICKUP_EVENTS.ASSIGN_PICKUP,
      appConstants.PICKUP_EVENTS.UNASSIGN_PICKUP,
    ].includes(event.eventName)
      ? {
          eventType: event.eventName,
          pickupIds: event.pickupIds,
        }
      : null;
    this.setState({
      showLoader: true,
      eventName: event?.label || event,
      isDataRefreshProgress: true,
      processedPickups: [],
    });

    this.timer = setTimeout(() => {
      //Start the timerr
      this.hideLoaderDialog(); //After 1 min, hide loader
      this.refreshDispatchStore();
    }, 60000);
  };

  hideLoaderDialog = () => {
    this.pendingPickupEvent = null;
    if (this.state.eventName?.toLowerCase().includes("pickup")) {
      Events.emit("PickupAssignmentCompleted");
    }
    this.setState({
      showLoader: false,
      isDataRefreshProgress: false,
      processedPickups: [],
      eventName: "",
    });
    clearTimeout(this.timer);
  };

  addDriverLocation = (
    terminalCode,
    driverId,
    latitude,
    longitude,
    eventTime
  ) => {
    if (this.props.userData.userProfile.terminal.code !== terminalCode) {
      return;
    }
    this.props.DispatchStore.addDriverLocation(
      driverId,
      latitude,
      longitude,
      eventTime
    );
  };

  populateStaticData = () => {
    const { DispatchStore } = this.props;
    Promise.all([
      getDataWithQueryString(
        "getClientData",
        `terminalCode=${this.props.userData.userProfile.terminal.code}`
      ),
      getDataWithQueryString(
        "getAllPackageCodes",
        `terminalCode=${this.props.userData.userProfile.terminal.code}`
      ),
      getDataWithQueryString(
        "GetAllHazmatInfo",
        `terminalCode=${this.props.userData.userProfile.terminal.code}`
      ),
    ]).then(([clientCodes, packageCodes, hazmatInfo]) => {
      if (clientCodes.status === 200 && packageCodes.status === 200) {
        DispatchStore.setStaticClientData({
          clientCodes: clientCodes.data,
          packageCodes: packageCodes.data,
        });
      }
      if (hazmatInfo.status === 200) {
        DispatchStore.setHazmatInfo(hazmatInfo.data);
      }
    });
  };

  updatePickupAcknowledgedStatus = (data) => {
    const { routeId, pickupId } = JSON.parse(data);
    this.props.DispatchStore.updatePickupAcknowledgedStatus(routeId, pickupId);
  };

  getUnreadMessages = () => {
    getDataWithAbort(
      "GetUnreadMessages",
      `terminalCode=${this.props.userData.userProfile.terminal.code}`
    )
      .then((unreadMessages) => {
        if (unreadMessages && unreadMessages.status === 200) {
          this.props.DispatchStore.addUnreadMessages(unreadMessages.data);
        } else {
          this.props.DispatchStore.addUnreadMessages([]);
        }
      })
      .catch(() => {});
  };

  refreshPickupList = () => {
    return getDataWithAbort(
      "PickupsGrid",
      `terminalCode=${this.props.userData.userProfile.terminal.code}`
    )
      .then((pickups) => {
        if (pickups && pickups.status === 200) {
          this.props.DispatchStore.addPickups(pickups.data);
          this.props.DispatchStore.showErrorMessageOnGrid(
            "pickupsGridMessage",
            appConstants.GRID_STATUS.SUCCESS
          );
        } else {
          this.props.DispatchStore.showErrorMessageOnGrid(
            "pickupsGridMessage",
            appConstants.GRID_STATUS.ERROR
          );
        }
      })
      .catch(() => {});
  };

  refreshAvailableDrivers = () => {
    getDataWithAbort(
      "GetAvailableDrivers",
      `terminalCode=${this.props.userData.userProfile.terminal.code}`
    )
      .then((response) => {
        let availableDrivers = [];
        if (response?.status === 200) {
          availableDrivers = response.data ?? [];
        }
        this.props.DispatchStore.setAvailableDriverList(availableDrivers);
      })
      .catch(() => {});
  };

  refreshDispatchRoutes = (driversToUpdate) => {
    const driverIds = driversToUpdate?.filter(Boolean);
    const driversQueryString = driverIds?.length
      ? `&driverIds=${JSON.stringify(
          driverIds.map((driverId) => driverId.toUpperCase())
        )}`
      : "";
    return getDataWithAbort(
      "DispatchedDrivers",
      `terminalCode=${this.props.userData.userProfile.terminal.code}${driversQueryString}`
    )
      .then((dispatchedDrivers) => {
        if (driverIds?.length) {
          this.updateDispatchedDrivers(dispatchedDrivers, driverIds);
        } else {
          this.replaceDispatchedDrivers(dispatchedDrivers);
        }
      })
      .catch(() => this.updateDriverRoutesFailure(driverIds));
  };

  replaceDispatchedDrivers = (dispatchedDrivers) => {
    if (dispatchedDrivers?.status === 200) {
      this.props.DispatchStore.addDispatchedDrivers(
        dispatchedDrivers.data,
        this.props.theme.routeMapColorPalette.IconsColors
      );
      this.props.DispatchStore.showErrorMessageOnGrid(
        "driversRouteGridMessage",
        appConstants.GRID_STATUS.SUCCESS
      );
    } else {
      this.props.DispatchStore.showErrorMessageOnGrid(
        "driversRouteGridMessage",
        appConstants.GRID_STATUS.ERROR
      );
    }
  };

  updateDispatchedDrivers = (dispatchedDrivers, driversToUpdate) => {
    if (dispatchedDrivers?.status === 200) {
      this.props.DispatchStore.updateDispatchedDrivers(
        dispatchedDrivers.data,
        driversToUpdate,
        this.props.theme.routeMapColorPalette.IconsColors
      );
    } else {
      this.updateDriverRoutesFailure(driversToUpdate);
    }
    if (this.state.showLoader) {
      this.hideLoaderDialog();
    }
  };

  updateDriverRoutesFailure = (driversToUpdate = []) => {
    // if data fetch failed , restore pending list to update in next call
    this.pendingUpdateDriverIds = [
      ...new Set([...this.pendingUpdateDriverIds, ...driversToUpdate]),
    ];
    if (this.state.showLoader) {
      this.hideLoaderDialog();
    }
  };

  refreshDispatchKPI = () => {
    const kpiDataPromise = getDataWithAbort(
      "DispatchKPI",
      `terminalCode=${this.props.userData.userProfile.terminal.code}`
    );
    kpiDataPromise
      .then((response) => {
        if (response && response.status === 200) {
          this.props.DispatchStore.updateKPIData(response.data);
        } else {
          this.props.DispatchStore.updateKPIData([]);
        }
        Events.emit("DispatchKPI", true);
      })
      .catch(() => {});
  };

  refreshDispatchStore = ({initialRefresh = false, driverIds = null, eventName = ""}) => {
    if (initialRefresh) {
      this.props.DispatchStore.showErrorMessageOnGrid(
        "all",
        appConstants.GRID_STATUS.LOADING
      );
    }
    this.getUnreadMessages();
    this.refreshAvailableDrivers();
    const refreshPickupPromise = this.refreshPickupList();
    const refreshDispatchRoutePromise = this.refreshDispatchRoutes(driverIds);
    this.refreshDispatchKPI();

    Promise.all([refreshPickupPromise, refreshDispatchRoutePromise]).then(this.dispatchDataRefreshComplete);

    if (eventName === "dispatchCancelled") {
      this.props.enqueueSnackbar("Dispatch cancelled successfully", {
        variant: "success",
      });
    }
  };

  dispatchDataRefreshComplete = () => {
    Events.emit("RefreshComplete", null);
    if (this.state.showLoader) {
      this.hideLoaderDialog();
    }
   }
  
  showPickupTerminalChangeMessage = (data) => {
    this.props.glEventHub.emit("DispatchEvents", "HideLoaderDialog", []);
    if (
      data.movedToTerminal == this.props.userData.userProfile.terminal.code &&
      data.movedFromTerminal
    ) {
      this.props.enqueueSnackbar(
        `${data.shipperName} moved from the terminal ${data.movedFromTerminal}.`,
        { variant: "success" }
      );
    } else if (
      data.movedFromTerminal == this.props.userData.userProfile.terminal.code &&
      data.movedToTerminal
    ) {
      this.props.enqueueSnackbar(
        `${data.shipperName} moved to the terminal ${data.movedToTerminal} successfully.`,
        { variant: "success" }
      );
    }
  };
  stopMoved = (data) => {
    const { routeId, driverId, isEventProcessed } = JSON.parse(data);
    const route = this.props.DispatchStore.getDispatchDriverRoute(
      driverId,
      routeId
    );
    if (isEventProcessed) {
      this.props.enqueueSnackbar(
        `Successfully updated stop sequence for ${route.driverName}, route ${route.routeName}`,
        { variant: "success" }
      );
    } else {
      this.props.enqueueSnackbar(
        `Failed to update stop sequence for driver ${route.driverName}, route ${route.routeName}`,
        { variant: "error" }
      );
    }
    this.updateDriverRoute(driverId);
  };

  handleChange = (event, value) => {
    this.setState({
      currentTabValue: value,
    });
  };

  onPickupUpdated = () => {
    this.refreshPickupList().then(() => {
      if (this.state.showLoader) {
        this.hideLoaderDialog();
      }
    });
    this.refreshDispatchKPI();
  };

  refreshDuplicatePickups = () => {
    getDataWithQueryString(
      "GetDuplicatePickups",
      `terminalCode=${this.props.userData.userProfile.terminal.code}`
    ).then((response) => {
      let duplicatePickups = [];
      if (response?.status === 200) {
        duplicatePickups = response.data ?? [];
      }
      this.props.DispatchStore.updateDuplicatePickups(duplicatePickups);
      Events.emit("RerenderDuplicatePickups");
    });
  };

  handleTerminalChange = (event) => {
    const terminalCode = event.target.labels[0].innerText;
    sessionStorage.setItem("selectedTerminal", event.target.value);
    this.props.glEventHub.emit(
      "UpdateDispatchStore",
      "updateSelectedRoutes",
      []
    );
    this.props.glEventHub.emit("DispatchEvents", "RefreshUserInfo", [
      event.target.value,
      `Switched to terminal ${terminalCode}`,
    ]);
    this.setState({
      terminalanchorEl: null,
      mainMenuAnchor: null,
    });
    this.props.glEventHub.emit("UpdateSpottedTrailers", terminalCode);
  };

  openDriverChatBox = (driverId) => {
    this.props.glEventHub.emit("OpenDriverChatBox", JSON.stringify(driverId));
  };

  getTerminalMenuData = () => {
    const groupDataByRegion = groupBy(
      this.props.userData.userProfile.terminals,
      "terminalRegion"
    );
    const terminalData = Object.keys(groupDataByRegion).sort();

    let options = terminalData.map((region) => ({
      region: region,
      regionTerminals: sortBy(groupDataByRegion[region], "terminalCode"),
    }));
    let activeTerminalData = this.props.userData.userProfile.terminals.find(
      (terminal) =>
        terminal.terminalCode === this.props.userData.userProfile.terminal.code
    );
    return { options, activeTerminalData };
  };

  handleTerminalClick = (event) => {
    this.setState({ terminalanchorEl: event.currentTarget });
  };

  openModuleSwitcher = (event) => {
    this.setState({ moduleSwitcherAnchor: event.currentTarget });
  };

  handleTerminalClose = () => {
    this.setState({ terminalanchorEl: null });
  };

  onModuleSwitcherClose = () => {
    this.setState({ moduleSwitcherAnchor: null });
  };

  shouldDialogOpen = (title, open = true) => {
    // open dispatchOptimization
    this.setState({
      title: title,
      isDialogOpen: open,
    });
    if (title === "dispatchOptimization") {
      this.setState({
        isPickupOptimizationInProgress: true,
      });
    }
  };

  closeDialog = () => {
    this.setState({
      isDialogOpen: false,
    });
    if (this.state.isPickupOptimizationInProgress) {
      this.setState({
        isPickupOptimizationInProgress: false,
      });
    }
  };

  getDialogComponent = (title) => {
    if (title === "dispatchOptimization") {
      return (
        <DispatchOptimizationDialog
          onClose={this.closeDialog}
          userData={this.props.userData}
          glEventHub={this.props.glEventHub}
        />
      );
    }
    return "";
  };

  openMainMenu = (event) => {
    this.setState({ mainMenuAnchor: event.currentTarget });
  };

  closeMainMenu = () => {
    this.setState({ mainMenuAnchor: null });
  };

  getPickupProcessingCount = () => {
    if (!this.pendingPickupEvent) {
      return "";
    }

    if (this.pendingPickupEvent.pickupIds.length) {
      return `${this.state.processedPickups.length + 1}/${
        this.state.processedPickups.length +
        this.pendingPickupEvent.pickupIds.length
      }`;
    } else {
      return `${this.state.processedPickups.length}/${this.state.processedPickups.length}`;
    }
  };

  render() {
    const { moduleSwitcherAnchor, mainMenuAnchor, terminalanchorEl } =
      this.state;
    const { classes } = this.props;
    const { options, activeTerminalData } = this.getTerminalMenuData();
    const menuProps = {
      openSettings: this.handleChange,
      shouldDialogOpen: this.shouldDialogOpen,
      terminalCode: this.props.userData.userProfile.terminal.code,
      isDataRefreshProgress: this.state.isDataRefreshProgress,
      handleTerminalClick: this.handleTerminalClick,
      width: this.props.width,
      closeMenu: this.closeMainMenu,
      userProfile: this.userProfileData,
      openDriverChatBox: this.openDriverChatBox,
    };
    const isNotificationPanelNotVisible =
      !["xl", "lg"].includes(this.props.width) && !Boolean(mainMenuAnchor);
    return (
      <div>
        {this.state.currentTabValue &&
          this.state.currentTabValue != this.props.path.url && (
            <Redirect to={this.state.currentTabValue} push />
          )}
        <AppBar
          position="sticky"
          className="appHeader"
          classes={{ root: classes.headerStyles }}
        >
          <Toolbar variant="dense" classes={{ gutters: classes.gutters }}>
            <div>
              <IconButton
                disableRipple={true}
                color="primary"
                onClick={this.openModuleSwitcher}
                data-automationid="hamburger-menu"
              >
                <Tooltip title="Switch Modules">
                  {/* <ViewList className={classes.mainMenu}/> */}
                  <i
                    className={`${classes.moduleSwitcher} icon-icon_burger_menu`}
                  />
                </Tooltip>
              </IconButton>
              <ModuleSwitcher
                menuAnchor={moduleSwitcherAnchor}
                onClose={this.onModuleSwitcherClose}
                handleModuleChange={this.handleChange}
                userProfile={this.props.userData.userProfile}
              />
            </div>
            <img
              className={classes.rmaxLogo}
              src="../../images/RouteMax_Logo_Orange_v2.svg"
            />
            <Tabs
              value={
                [
                  DispatchTabs.assetManagement.path,
                  DispatchTabs.routeExecution.path,
                  DispatchTabs.driverPerformance.path,
                ].includes(this.state.currentTabValue)
                  ? this.state.currentTabValue
                  : false
              }
              classes={{
                root: classes.tabsRoot,
                indicator: classes.tabsIndicator,
              }}
              onChange={this.handleChange}
            >              
              <Tab
                value={DispatchTabs.routeExecution.path}
                label={DispatchTabs.routeExecution.label}
                id={DispatchTabs.routeExecution.id}
                classes={{
                  root: classes.tabRoot,
                  selected: classes.tabSelected,
                }}
              />
              <Tab
                value={DispatchTabs.assetManagement.path}
                label={DispatchTabs.assetManagement.label}
                id={DispatchTabs.assetManagement.id}
                classes={{
                  root: classes.tabRoot,
                  selected: classes.tabSelected,
                }}
              />
              <Tab
                value={DispatchTabs.driverPerformance.path}
                label={DispatchTabs.driverPerformance.label}
                id={DispatchTabs.driverPerformance.id}
                classes={{
                  root: classes.tabRoot,
                  selected: classes.tabSelected,
                }}
              />
            </Tabs>
            <div className={classes.grow}></div>
            <div className={classes.headerIcons}>
              {this.props.width === "xl" || this.props.width === "lg" ? (
                <RightNavigationMenu
                  {...menuProps}
                  switchNotificationPanel={this.switchNotificationPanel}
                  showNotification={this.state.showNotification}
                />
              ) : (
                <Menu
                  disablePortal={true}
                  getContentAnchorEl={null}
                  disableAutoFocusItem={true}
                  transformOrigin={{ vertical: "top", horizontal: "right" }}
                  open={Boolean(mainMenuAnchor)}
                  anchorEl={mainMenuAnchor}
                  onClose={this.closeMainMenu}
                  MenuListProps={{ disablePadding: true }}
                  classes={{
                    paper: classes.mainMenu,
                  }}
                  anchorOrigin={{ vertical: "top", horizontal: "right" }}
                >
                  <RightNavigationMenu
                    {...menuProps}
                    switchNotificationPanel={this.switchNotificationPanel}
                    showNotification={this.state.showNotification}
                  />
                </Menu>
              )}
              {isNotificationPanelNotVisible || !this.state.showNotification ? (
                <ToastNotifications
                  openDriverChatBox={this.openDriverChatBox}
                />
              ) : null}
            </div>
            <div className={classes.toggledMenu}>
              <IconButton
                color="inherit"
                className={classes.mainMenuButton}
                onClick={this.openMainMenu}
              >
                <Tooltip title="Main Menu">
                  <MoreVert style={{ fontSize: "21px" }} />
                </Tooltip>
              </IconButton>
            </div>
          </Toolbar>
          <Suspense fallback={<AppLoading />}>
            {this.state.isDialogOpen &&
              this.state.title &&
              this.getDialogComponent(this.state.title)}
            {this.state.terminalanchorEl && (
              <TerminalSelect
                terminalAnchor={terminalanchorEl}
                closeTerminalmenu={this.handleTerminalClose}
                terminalOptions={options}
                handleTerminalChange={this.handleTerminalChange}
                activeTerminal={activeTerminalData}
              />
            )}
            {this.state.showLoader && (
              <LoaderDialog
                eventName={`${
                  this.state.eventName
                } ${this.getPickupProcessingCount()}`.trim()}
              ></LoaderDialog>
            )}
          </Suspense>
        </AppBar>
        <ParameterListener
          scenarioId={this.props.userData.userProfile.scenarioID}
        />
      </div>
    );
  }
}
export default compose(
  withWidth(),
  withTheme(),
  withStyles(styles),
  withRouter,
  withUserProfile,
  withSnackbar
)(DispatchHeader);
